// var swiper = new Swiper.default('.swiper-container', {
//   loop: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev'
//   },
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true
//   }

// });


var swiperReferences = new Swiper.default('.slider--references', {
  slidesPerView: 3,
  navigation: {
    nextEl: '.swiper-button-next--references',
    prevEl: '.swiper-button-prev--references'
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  breakpoints: {
    1200: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 1,
    },
  }
});


